import { BlurbProvider } from '../context/Blurb.context';
import { AuthLayout } from '../layouts/auth.layout';
import { BlurbLayout } from '../layouts/blurb.layout';
import { CartLayout } from '../layouts/cart.layout';
import { CheckoutLayout } from '../layouts/checkout.layout';
import { UserLayout } from '../layouts/user.layout';
import { redirectLoader, registrationLoader, signOutLoader } from '../loaders';
import { MAIN_REDIRECT } from '../utils/constants';
import { SettingsView } from './account/SettingsView';
import { AddAddress } from './addresses/add-address.route';
import { AddressBook } from './addresses/address-book.route';
import { EditAddress } from './addresses/edit-address.route';
import { BlurbyRegisterRoute } from './auth/blurby-register.route';
import { ConfirmForgotPasswordRoute } from './auth/confirm-forgot-password.route';
import { ConfirmSignUpRoute } from './auth/confirm-sign-up.route';
import { ExpiredVerification } from './auth/expired-verification.route';
import { ForgotEmailSentRoute } from './auth/forgot-email-sent.route';
import { ForgotPasswordRoute } from './auth/forgot-password.route';
import { LoginSuccessRoute } from './auth/login-success.route';
import { LogInRoute } from './auth/login.route';
import { OidcCallbackRoute } from './auth/oidc-callback.route';
import { SignInRoute } from './auth/sign-in.route';
import { SignUpRoute } from './auth/sign-up.route';
import { CartRoute } from './cart/cart.route';
import { CheckoutRoute } from './checkout/checkout.route';
import DashboardRoute from './dashboard/dashboard.route';
import { ProjectsRoute } from './projects/projects.route';
import { Navigate, RouteObject } from 'react-router-dom';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/auth" replace />,
  },
  {
    path: '/v2',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        loader: redirectLoader('/v2/auth/login'),
      },
      {
        path: 'auth',
        children: [
          {
            index: true,
            element: <LogInRoute />,
          },
          {
            path: 'login',
            element: <LogInRoute />,
          },
          {
            path: 'login-success',
            element: <LoginSuccessRoute />,
          },
          {
            path: 'register',
            element: <BlurbyRegisterRoute />,
          },
        ],
      },
    ],
  },

  {
    path: '/v1',
    element: <AuthLayout />,
    children: [
      {
        path: 'auth',
        children: [{ path: 'callback/oidc', element: <OidcCallbackRoute /> }],
      },
    ],
  },

  {
    path: 'auth',
    element: <AuthLayout />,
    children: [
      {
        index: true,
        loader: redirectLoader('/auth/sign-in'),
      },
      {
        path: 'forgot-password',
        children: [
          {
            index: true,
            element: <ForgotPasswordRoute />,
          },
          {
            path: 'email-sent',
            element: <ForgotEmailSentRoute />,
          },
          {
            path: 'confirm/:token',
            element: <ConfirmForgotPasswordRoute />,
          },
        ],
      },
      {
        path: 'sign-in',
        element: <SignInRoute />,
      },
      {
        path: 'sign-out',
        loader: signOutLoader,
      },
      {
        path: 'sign-up',
        children: [
          {
            index: true,
            element: <SignUpRoute />,
          },
          {
            path: 'confirm',
            children: [
              {
                index: true,
                element: <ConfirmSignUpRoute />,
              },
              {
                path: ':token',
                loader: registrationLoader,
              },
              {
                path: 'verification-expired',
                element: <ExpiredVerification />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'user',
    element: (
      <BlurbProvider>
        <BlurbLayout />
      </BlurbProvider>
    ),
    children: [
      {
        path: 'account',
        element: <UserLayout />,
        children: [
          {
            path: 'settings',
            element: <SettingsView />,
          },
          {
            path: 'address-book',
            children: [
              { index: true, element: <AddressBook /> },
              { path: 'add', element: <AddAddress /> },
              { path: ':id', element: <EditAddress /> },
            ],
          },
        ],
      },
      {
        path: 'dashboard',
        element: <UserLayout />,
        children: [
          {
            index: true,
            element: <DashboardRoute />,
          },
        ],
      },
      {
        path: 'projects',
        element: <UserLayout />,
        children: [
          {
            index: true,
            element: <ProjectsRoute />,
          },
        ],
      },
      {
        path: 'checkout',
        element: <CheckoutLayout />,
        children: [
          {
            index: true,
            element: <CheckoutRoute />,
          },
        ],
      },
      {
        path: 'cart',
        element: <CartLayout />,
        children: [
          {
            index: true,
            element: <CartRoute />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={MAIN_REDIRECT} replace />,
  },
];
